<template>
    <div :class="[classNames+'-upload-img-list', {[classNames+'-upload-img-list-column']: flexDirection === 'column'}]">
        <uploadImgItem :dataType="type" :dyProps.sync="ruleForm[item.dyProp]"  v-model="ruleForm[item.prop]" v-for="(item, index) in data" :item="item" :currIndex="index"  :isSubmitFlag="isSubmitFlag" :is_disabled="is_disabled" :flexDirection="flexDirection" :key="index" :is_material="is_material">
        </uploadImgItem>
    </div>
</template>
<script>
import uploadImgItem from './uploadImgItem.vue' 
export default {
    inheritAttrs: true,
    props: {
        data: {
            type: Array,
            default: () => []
        },
        ruleForm:  {
            type: Object,
            default: () => {
                return {}
            }
        },
        isSubmitFlag: {
            type: Boolean,
            default: false
        },
        is_disabled: {
            type: Boolean,
            default: false
        },
        flexDirection: {
            type: String,
            default: 'row'
        },
        timesFlag: {
            type: Boolean,
            default: false
        },
        type:{
            type:[String,Number],
            default:1
        },
		is_material: {
            type: Boolean,
            default: true
        }
    },
    components: {
        uploadImgItem
    },
    data() {
        return {
            classNames: 'page',
            previewSrcList: [],
            times: []
        }
    },
    computed: {
    },
    mounted() {
    },
    methods: {
        editAvatarUrl(name) {
            this.$emit('change', name)
        },
        deleteItem(name) {
            this.$emit('deleteItem', name)
        },
        beforeUpload(list){
            console.log('909000',list)
            this.$emit('beforeUpload', list)
        }
    }
}
</script>

<style lang="less">
    @classNames: page;
    .@{classNames}-upload-img-list {
        display: flex;
        flex-wrap: wrap;
        &.@{classNames}-upload-img-list-column {
            flex-direction: column;
            align-items: flex-start;
             .@{classNames}-upload-img-list-item {
                align-items: flex-start;
                &:not(:last-child) {
                    margin-right: 0;
                    margin-bottom: 12px;
                }
             }
           
        }
    }
</style>